import { Collection, ModelRow } from "@mcleod/core";
import { LayoutCache } from "./LayoutCache";

/**
 * This class exists to provide access to clear layouts from the layout cache, without providing full access to the
 * cache itself.
 */
export class LayoutCacheAccessor {
    public static clearAll() {
        LayoutCache.clearAll();
    }

    public static clear(name: string): void {
        LayoutCache.clear(name);
    }

    public static getCopy(): Collection<ModelRow> {
        return LayoutCache.getCopy();
    }

    public static putAll(sourceCache: Collection<ModelRow>) {
        LayoutCache.putAll(sourceCache);
    }

    public static isEmpty(): boolean {
        return LayoutCache.isEmpty();
    }
}
